var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiveOffice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 99.998,
    viewBox: "0 0 103 99.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Certificate_-_Free_real_estate_icons-2",
    "data-name": "Certificate - Free real estate icons-2",
    transform: "translate(0 -8.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10283",
    "data-name": "Group 10283",
    transform: "translate(0 8.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1_39_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_40---Certificate"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_91_",
    d: "M96.133,8.533H6.867A6.882,6.882,0,0,0,0,15.43V89.567a6.882,6.882,0,0,0,6.867,6.9H20.6v8.621a3.441,3.441,0,0,0,3.433,3.448,3.38,3.38,0,0,0,1.761-.491l5.105-3.09,5.1,3.083a3.433,3.433,0,0,0,5.2-2.95V96.463H96.133a6.882,6.882,0,0,0,6.867-6.9V15.43a6.882,6.882,0,0,0-6.867-6.9ZM17.943,75.989a9.517,9.517,0,0,0-2.414-3.036c-.841-.8-1.8-1.722-1.8-2.352s.955-1.552,1.8-2.352a9.522,9.522,0,0,0,2.414-3.036,9.948,9.948,0,0,0,.467-3.981c-.019-1.081-.045-2.426.352-2.822s1.739-.376,2.81-.355a9.82,9.82,0,0,0,3.962-.467,9.45,9.45,0,0,0,3.026-2.426c.8-.843,1.715-1.8,2.34-1.8s1.536.959,2.34,1.8a9.445,9.445,0,0,0,3.026,2.426,9.838,9.838,0,0,0,3.962.467c1.068-.016,2.417-.043,2.81.355s.371,1.741.343,2.822a9.948,9.948,0,0,0,.467,3.981,9.517,9.517,0,0,0,2.414,3.036c.85.8,1.8,1.722,1.8,2.352s-.955,1.552-1.8,2.352a9.522,9.522,0,0,0-2.414,3.036,9.948,9.948,0,0,0-.467,3.981c.019,1.081.045,2.426-.343,2.822s-1.739.372-2.81.355H39.47a8.132,8.132,0,0,0-3.195.474,9.45,9.45,0,0,0-3.026,2.426c-.8.836-1.723,1.795-2.348,1.795s-1.536-.959-2.34-1.8a9.445,9.445,0,0,0-3.026-2.426,8.019,8.019,0,0,0-3.111-.478H22.3c-.244,0-.487,0-.73.009-1.066.021-2.415.043-2.81-.355s-.371-1.741-.352-2.822A9.947,9.947,0,0,0,17.943,75.989Zm13.843,25.474a1.71,1.71,0,0,0-1.772,0l-5.981,3.621V86.751a1.735,1.735,0,0,1,.185.05,7.429,7.429,0,0,1,1.857,1.619A7.067,7.067,0,0,0,30.9,91.291a7.067,7.067,0,0,0,4.824-2.871A7.429,7.429,0,0,1,37.582,86.8c.053-.022.127-.033.185-.052v18.332Zm67.781-11.9a3.441,3.441,0,0,1-3.433,3.448H41.2V86.6a5.77,5.77,0,0,0,4.266-1.379A6.94,6.94,0,0,0,46.824,79.9a7.825,7.825,0,0,1,.206-2.6,7.461,7.461,0,0,1,1.612-1.865A7.109,7.109,0,0,0,51.5,70.6a7.109,7.109,0,0,0-2.858-4.845,7.465,7.465,0,0,1-1.612-1.865,7.825,7.825,0,0,1-.206-2.6,6.941,6.941,0,0,0-1.358-5.322,6.871,6.871,0,0,0-5.3-1.364,7.674,7.674,0,0,1-2.585-.207,7.428,7.428,0,0,1-1.857-1.619A7.067,7.067,0,0,0,30.9,49.912a7.067,7.067,0,0,0-4.824,2.871A7.428,7.428,0,0,1,24.219,54.4a7.812,7.812,0,0,1-2.585.207,6.884,6.884,0,0,0-5.3,1.364,6.94,6.94,0,0,0-1.358,5.319,7.825,7.825,0,0,1-.206,2.6,7.461,7.461,0,0,1-1.612,1.865A7.11,7.11,0,0,0,10.3,70.6a7.109,7.109,0,0,0,2.858,4.845,7.467,7.467,0,0,1,1.605,1.865,7.825,7.825,0,0,1,.206,2.6,6.941,6.941,0,0,0,1.358,5.322,5.765,5.765,0,0,0,4.266,1.379v6.405H6.867a3.441,3.441,0,0,1-3.433-3.448V15.43a3.441,3.441,0,0,1,3.433-3.448H96.133a3.441,3.441,0,0,1,3.433,3.448Z",
    transform: "translate(0 -8.533)",
    fill: "#286c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_90_",
    d: "M112.745,285.223A10.345,10.345,0,1,0,102.4,274.878,10.345,10.345,0,0,0,112.745,285.223Zm0-17.241a6.9,6.9,0,1,1-6.9,6.9A6.9,6.9,0,0,1,112.745,267.981Z",
    transform: "translate(-81.822 -212.809)",
    fill: "#286c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_89_",
    d: "M302.465,108.111V99.023a3.448,3.448,0,0,0-3.448-3.448h-3.448a3.448,3.448,0,0,0-3.429,3.259L287.6,94.759a3.562,3.562,0,0,0-4.762,0l-17.145,15.4a3.462,3.462,0,0,0-.929,3.84,3.5,3.5,0,0,0,3.214,2.25v17.255a3.448,3.448,0,0,0,3.448,3.448h27.586a3.448,3.448,0,0,0,3.448-3.448V116.251a3.5,3.5,0,0,0,3.214-2.241,3.46,3.46,0,0,0-.931-3.84Zm-6.9-9.088h3.448v5.99l-3.448-3.1Zm-10.267-1.7,17.065,15.491H285.224L268,112.726Zm-1.8,36.181v-5.172a1.724,1.724,0,1,1,3.448,0v5.172Zm6.9,0v-5.172a5.172,5.172,0,1,0-10.345,0v5.172h-8.621V116.264h27.586v17.241Z",
    transform: "translate(-211.534 -76.609)",
    fill: "#286c4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10282",
    "data-name": "Group 10282",
    transform: "translate(6.897 6.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101_",
    d: "M101.025,136.533H69.991a1.724,1.724,0,0,0,0,3.448h31.034a1.724,1.724,0,0,0,0-3.448Z",
    transform: "translate(-61.371 -117.568)",
    fill: "#286c4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100_",
    d: "M101.025,179.2H69.991a1.724,1.724,0,0,0,0,3.448h31.034a1.724,1.724,0,0,0,0-3.448Z",
    transform: "translate(-61.371 -151.614)",
    fill: "#286c4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99_",
    d: "M230.575,95.591a1.724,1.724,0,0,0-1.724-1.724H215.058a1.724,1.724,0,1,0,0,3.448h13.793A1.724,1.724,0,0,0,230.575,95.591Z",
    transform: "translate(-177.375 -83.522)",
    fill: "#286c4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98_",
    d: "M180.924,54.649H208.51a1.724,1.724,0,1,0,0-3.448H180.924a1.724,1.724,0,0,0,0,3.448Z",
    transform: "translate(-150.144 -49.477)",
    fill: "#286c4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97_",
    d: "M42.754,44.391a1.724,1.724,0,0,0-1.724-1.724H35.858a1.724,1.724,0,0,0-1.724,1.724v5.172a1.724,1.724,0,0,0,3.448,0V46.115H41.03A1.724,1.724,0,0,0,42.754,44.391Z",
    transform: "translate(-34.134 -42.667)",
    fill: "#286c4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96_",
    d: "M319.444,332.8H291.858a1.724,1.724,0,0,0,0,3.448h27.586a1.724,1.724,0,1,0,0-3.448Z",
    transform: "translate(-238.858 -274.18)",
    fill: "#286c4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95_",
    d: "M319.444,375.467H291.858a1.724,1.724,0,0,0,0,3.448h27.586a1.724,1.724,0,0,0,0-3.448Z",
    transform: "translate(-238.858 -308.226)",
    fill: "#286c4d",
    fillRule: "evenodd"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiveOffice);
export default __webpack_public_path__ + "static/media/giveOffice.2363f7cc1d8a595f3535dc2cd81fd18c.svg";
export { ForwardRef as ReactComponent };